import { RESET_STATE } from 'store/global/actions';

import { CAPTURE_POLICY_ACTION_TYPE } from '../actions';

const initialState = {
  list: { data: [], isLoading: false, hasError: false, isForbidden: false },
  mutation: { isSaving: false, errorMessage: null },
};

const upsertRow = (rows, saved) => {
  const exists = rows.some(item => item.capturePolicyRowId === saved.capturePolicyRowId);

  return exists
    ? rows.map(item => (item.capturePolicyRowId === saved.capturePolicyRowId ? saved : item))
    : [...rows, saved];
};

const capturePolicyReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case CAPTURE_POLICY_ACTION_TYPE.SET_CAPTURE_LOADING:
      return {
        ...state,
        list: {
          ...state.list,
          isLoading: payload,
          hasError: payload ? false : state.list.hasError,
          isForbidden: payload ? false : state.list.isForbidden,
        },
      };

    case CAPTURE_POLICY_ACTION_TYPE.SET_CAPTURE_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          isLoading: false,
          hasError: true,
          isForbidden: !!payload?.isForbidden,
        },
      };

    case CAPTURE_POLICY_ACTION_TYPE.GET_CAPTURE_ROWS:
      return {
        ...state,
        list: { data: payload ?? [], isLoading: false, hasError: false, isForbidden: false },
      };

    case CAPTURE_POLICY_ACTION_TYPE.SET_CAPTURE_SAVING:
      return { ...state, mutation: { isSaving: payload, errorMessage: null } };

    case CAPTURE_POLICY_ACTION_TYPE.SET_CAPTURE_SAVE_ERROR:
      return { ...state, mutation: { isSaving: false, errorMessage: payload ?? null } };

    case CAPTURE_POLICY_ACTION_TYPE.UPSERT_CAPTURE_ROW:
      return {
        ...state,
        list: { ...state.list, data: upsertRow(state.list.data, payload) },
        mutation: { isSaving: false, errorMessage: null },
      };

    case CAPTURE_POLICY_ACTION_TYPE.REMOVE_CAPTURE_ROW:
      return {
        ...state,
        list: {
          ...state.list,
          data: state.list.data.filter(item => item.capturePolicyRowId !== payload),
        },
      };

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default capturePolicyReducer;
